const openJK = false;

export default {
  openJK
}